module.exports = () => ({
  restrict: 'A',
  scope: {
    textTruncate: '=',
    charsThreshold: '@',
    moreLabel: '@',
    lessLabel: '@',
  },
  controllerAs: 'truncate',
  controller: class TextTruncateController {
    static $inject = [
      '$scope',
      '$element',
      '$compile',
    ];

    constructor(
      $scope,
      $element,
      $compile,
    ) {
      this.$scope = $scope;
      this.$element = $element;
      this.$compile = $compile;

      this.$scope.open = false;

      this.charsThreshold = parseInt(this.$scope.charsThreshold);

      this.truncate();
    }

    truncate() {
      this.$scope.$watch('textTruncate', this.onTextChange());
    }

    toggleShow() {
      this.$scope.open = !this.$scope.open;
    }

    onTextChange() {
      this.$element.empty();

      if (this.$scope.textTruncate && this.truncationApplies(this.charsThreshold)) {
        this.applyCharBasedTruncation(this.charsThreshold, this.$scope, this.$element);
      } else {
        this.$element.append(this.$scope.textTruncate);
      }
    }

    truncationApplies(threshold) {
      return this.$scope.textTruncate.length > threshold;
    }

    applyCharBasedTruncation(threshold) {
      const el = angular.element(`<span>${
        this.$scope.textTruncate.substr(0, threshold)
        }<span ng-show='!open'>...</span>` +
        '<span class=\'btn-link truncate-toggle-text -show-more\' ' +
        'ng-click=\'truncate.toggleShow()\'' +
        'ng-show=\'!open\'>' +
        ` ${this.$scope.moreLabel ? this.$scope.moreLabel : 'Details'
        }</span>` +
        `<span ng-show='open'>${
        this.$scope.textTruncate.substring(threshold)
        }<span class='btn-link truncate-toggle-text -show-less'` +
        'ng-click=\'truncate.toggleShow()\'>' +
        ` ${this.$scope.lessLabel ? this.$scope.lessLabel : 'Show less'
        }</span>` +
        '</span>' +
        '</span>');
      this.$compile(el)(this.$scope);
      this.$element.append(el);
    }
  },
});



// WEBPACK FOOTER //
// ./main/directives/text-truncate.js